export enum ButtonAction {
  Accept = 'ACCEPT',
  Activate = 'ACTIVATE',
  Apply = 'APPLY',
  Approve = 'APPROVE',
  Cancel = 'CANCEL',
  Clone = 'CLONE',
  Close = 'CLOSE',
  Check = 'CHECK',
  Continue = 'CONTINUE',
  Create = 'CREATE',
  Edit = 'EDIT',
  Deactivate = 'DEACTIVATE',
  Delete = 'DELETE',
  GoBack = 'GO_BACK',
  Ok = 'OK',
  Publish = 'PUBLISH',
  Reset = 'RESET',
  Return = 'RETURN',
  Request = 'REQUEST',
  Save = 'SAVE',
  Search = 'SEARCH',
  Send = 'SEND',
  Update = 'UPDATE',
  Navigate = 'NAVIGATE',
  Yes = 'YES',
}

export enum ButtonType {
  Primary = 'PRIMARY',
  Accent = 'ACCENT',
  Secondary = 'SECONDARY',
  Custom = 'CUSTOM',
}

export enum ButtonSize {
  XS = 'xs',
  S = 's',
  M = 'm',
  L = 'l',
}
